import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import CreateFAQForm from '../../../modules/faqs/components/CreateFAQForm';

const CreateFAQ = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const title = id ? t('edit_faq') : t('create_faq');
  dispatch(
    setBreadCrumbsData({
      links: [{ label: title, path: '/faqs/create-faq' }],
      page_title: title
    })
  );

  return (
    <div>
      <CreateFAQForm />
    </div>
  );
};

export default CreateFAQ;
